<div class="main-container">
  <div class="grid-container" id="8883report-grid-container" style="height: calc(100vh - 124px);">
    <div class="top-toolbar">
      <div class="toolbar-actions">
        @if (taxyearLoaded) {
<ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYearItem" (onSelect)="onTaxYearChanged($event)">
  @for (item of taxYearItems; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item" [ariaLabel]="setTaxYearAriaLabel(item)" (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
}
        <gtw-df-me-dropdown class="top-filter-select me-dropdown-label" [customActionCode]="32136"
                            (selectedMes)="selectedMeChanged($event)">
        </gtw-df-me-dropdown>
        <ap-button [compact]="true" [btnType]="'primary'" [label]="'Filter'" (onClick)="loadReport()"></ap-button>
        <span class="toolbar-export" (click)="exportToExcel()">
          <span class="Appkit4-icon icon-save-outline"></span>
          <span>Export to Excel</span>
        </span>
      </div>
    </div>

    <div class="dst-mat-grid-layout">
      @if (loading) {
        <div class="dst-mat-grid-loading">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      }
      <div class="dst-mat-grid">
        <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort #matSort="matSort"
               (matSortChange)="onMatSortChange()" class="dst-mat-table">

          <ng-container matColumnDef="STATEMENTID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[0])">{{ cols[0].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[0])">
              <a href="javascript:void(0);" (click)="showViewUpdateStatement(rowData)">
                <span>{{ rowData.STATEMENTID }}</span>
              </a>
            </td>
          </ng-container>
          <ng-container matColumnDef="Project_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[1])">{{ cols[1].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[1])">
              <span>{{ rowData.Project_name }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="PRIMARYLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[2])">{{ cols[2].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[2])">
              <span>{{ rowData.PRIMARYLEID }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="PRIMARYENTITY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[3])">{{ cols[3].header }}</th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[3])">
              <span>{{ rowData.PRIMARYENTITY }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CHOICE1CTARGET_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[4])">{{ cols[4].header }}</th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[4])">
              <span>{{ rowData.CHOICE1CTARGET_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="FILING_GROUP">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[5])">{{ cols[5].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[5])">
              <span>{{ rowData.FILING_GROUP }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="OTHERPARTY_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[6])">{{ cols[6].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[6])">
              <span>{{ rowData.OTHERPARTY_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="EINAPPOP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[7])">{{ cols[7].header }}</th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[7])">
              <span>{{ rowData.EINAPPOP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="EINAPPMROP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[8])">{{ cols[8].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[8])">
              <span>{{ rowData.EINAPPMROP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="ADDRESSOFOTHERPARTY1_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[9])">{{ cols[9].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[9])">
              <span>{{ rowData.ADDRESSOFOTHERPARTY1_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="ADDRESSOFOTHERPARTY2_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[10])">{{ cols[10].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[10])">
              <span>{{ rowData.ADDRESSOFOTHERPARTY2_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CITYOFOTHERPARTY_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[11])">{{ cols[11].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[11])">
              <span>{{ rowData.CITYOFOTHERPARTY_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="PROVORSTATEOP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[12])">{{ cols[12].header }}</th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[12])">
              <span>{{ rowData.PROVORSTATEOP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="COUNTRYOFOP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[13])">{{ cols[13].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[13])">
              <span>{{ rowData.COUNTRYOFOP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="ZIPCODEOFOTHERPARTY_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[14])">{{ cols[14].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[14])">
              <span>{{ rowData.ZIPCODEOFOTHERPARTY_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="SECONDARYLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[15])">{{ cols[15].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[15])">
              <span>{{ rowData.SECONDARYLEID }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="SECONDARYENTITY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[16])">{{ cols[16].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[16])">
              <span>{{ rowData.SECONDARYENTITY }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="FMV_CURRENCY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[17])">{{ cols[17].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[17])">
              <span>{{ rowData.SECONDARYEIN }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="ACQUISIONDATE_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[18])">{{ cols[18].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[18])">
              <span>{{ rowData.ACQUISIONDATE_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="STOCKPRICE_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[19])">{{ cols[19].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[19])">
              <span gtwLineSplitter [inputString]="rowData.STOCKPRICE_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.STOCKPRICE_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="ACQUISITIONCOSTSC_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[20])">{{ cols[20].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[20])">
              <span gtwLineSplitter [inputString]="rowData.ACQUISITIONCOSTSC_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.ACQUISITIONCOSTSC_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="TARGETLIABILITIES_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[21])">{{ cols[21].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[21])">
              <span gtwLineSplitter [inputString]="rowData.TARGETLIABILITIES_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.TARGETLIABILITIES_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="AGUBORADSP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[22])">{{ cols[22].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[22])">
              <span gtwLineSplitter [inputString]="rowData.AGUBORADSP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.AGUBORADSP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CHOICE6_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[23])">{{ cols[23].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[23])">
              <span>{{ rowData.CHOICE6_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CHOICE7_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[24])">{{ cols[24].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[24])">
              <span>{{ rowData.CHOICE7_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CHOICE8A_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[25])">{{ cols[25].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[25])">
              <span>{{ rowData.CHOICE8A_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CHOICE8B_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[26])">{{ cols[26].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[26])">
              <span>{{ rowData.CHOICE8B_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CHOICE8C_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[27])">{{ cols[27].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[27])">
              <span>{{ rowData.CHOICE8C_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CHOICE8D_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[28])">{{ cols[28].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[28])">
              <span>{{ rowData.CHOICE8D_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CHOICE8E_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[29])">{{ cols[29].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[29])">
              <span>{{ rowData.CHOICE8E_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CHOICE8F_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[30])">{{ cols[30].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[30])">
              <span>{{ rowData.CHOICE8F_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS1AFMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[31])">{{ cols[31].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[31])">
              <span gtwLineSplitter [inputString]="rowData.CLASS1AFMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS1AFMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS2AFMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[32])">{{ cols[32].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[32])">
              <span gtwLineSplitter [inputString]="rowData.CLASS2AFMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS2AFMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS3AFMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[33])">{{ cols[33].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[33])">
              <span gtwLineSplitter [inputString]="rowData.CLASS3AFMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS3AFMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS4AFMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[34])">{{ cols[34].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[34])">
              <span gtwLineSplitter [inputString]="rowData.CLASS4AFMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS4AFMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS5AFMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[35])">{{ cols[35].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[35])">
              <span gtwLineSplitter [inputString]="rowData.CLASS5AFMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS5AFMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS6N7AFMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[36])">{{ cols[36].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[36])">
              <span gtwLineSplitter [inputString]="rowData.CLASS6N7AFMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS6N7AFMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="TOTALAFMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[37])">{{ cols[37].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[37])">
              <span gtwLineSplitter [inputString]="rowData.TOTALAFMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.TOTALAFMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS1ASPPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[38])">{{ cols[38].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[38])">
              <span gtwLineSplitter [inputString]="rowData.CLASS1ASPPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS1ASPPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS2ASPPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[39])">{{ cols[39].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[39])">
              <span gtwLineSplitter [inputString]="rowData.CLASS2ASPPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS2ASPPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS3ASPPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[40])">{{ cols[40].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[40])">
              <span gtwLineSplitter [inputString]="rowData.CLASS3ASPPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS3ASPPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS4ASPPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[41])">{{ cols[41].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[41])">
              <span gtwLineSplitter [inputString]="rowData.CLASS4ASPPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS4ASPPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS5ASPPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[42])">{{ cols[42].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[42])">
              <span gtwLineSplitter [inputString]="rowData.CLASS5ASPPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS5ASPPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS6N7ASPPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[43])">{{ cols[43].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[43])">
              <span gtwLineSplitter [inputString]="rowData.CLASS6N7ASPPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS6N7ASPPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="TOTALASPPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[44])">{{ cols[44].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[44])">
              <span gtwLineSplitter [inputString]="rowData.TOTALASPPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.TOTALASPPR_VAL }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 45px;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 70px;"></tr>
        </table>
      </div>
    </div>
  </div>
</div>

@if (showModalViewer) {
<dst-disc-modal-viewer [rowObject]="activeRow" (afterModalClosed)="afterModalClosed()">
</dst-disc-modal-viewer>
}
